(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-soccer/assets/javascripts/match.js') >= 0) return;  svs.modules.push('/components/themes/sport-soccer/assets/javascripts/match.js'); 
var svs = svs || {};

(function(svs, _) {
  svs.themes = svs.themes || {};
  svs.themes.sport_soccer = svs.themes.sport_soccer || {};
  svs.themes.sport_soccer.getLatestMatchesHomeAwayFilter = function() {
    return {
      all: { name: 'Alla', selected: true },
      home: { name: 'Hemma', selected: false },
      away: { name: 'Borta', selected: false }
    };
  };

  svs.themes.sport_soccer.formatModelData = function(data) {
    var status = 0;
    if (((data || {}).events || {}).status) {
      status = data.events.status;
    }
    if (this.isLive(status)) return this.doFormatModelDataLive(data);
    return this.doFormatModelData(data);
  };

  svs.themes.sport_soccer.doFormatModelDataLive = function(data) {
    var response = data;
    response.events.chronologicalList = _.sortBy(
      response.events.chronologicalList,
      function(item) {
        return parseInt(item.time, 10);
      }
    );
    if (_.isObject(response.events)) {
      if (_.isObject(response.events.chronologicalList)) {
        _.each(response.events.chronologicalList, function(eventItem) {
          if (_.isObject(eventItem.extendedTime)) {
            eventItem.formatedTime = eventItem.extendedTime.time;
            eventItem.period = eventItem.extendedTime.period;
          } else if (_.isString(eventItem.time)) {
            if (eventItem.time === 'Okänd tid') {
              eventItem.time = 0;
            }

            if (
              parseInt(eventItem.time, 10) >= 0 &&
              parseInt(eventItem.time, 10) < 46
            ) {
              eventItem.period = 1;
            } else if (
              parseInt(eventItem.time, 10) > 45 &&
              parseInt(eventItem.time, 10) < 91
            ) {
              eventItem.period = 2;
            } else if (
              parseInt(eventItem.time, 10) > 90 &&
              parseInt(eventItem.time, 10) < 106
            ) {
              eventItem.period = 3;
            } else if (
              parseInt(eventItem.time, 10) > 105 &&
              parseInt(eventItem.time, 10) < 121
            ) {
              eventItem.period = 5;
            } else if (parseInt(eventItem.time, 10) === 0) {
              eventItem.period = 99;
            }
            eventItem.formatedTime = eventItem.time + "'";
          }
        });

        this.removeInsufficientEvents(response.events.chronologicalList);

        var groupedEvents = _.groupBy(
          response.events.chronologicalList,
          function(eventItem) {
            return eventItem.period;
          }
        );

        groupedEvents = this.formatGoalResult(groupedEvents);
        groupedEvents = _.sortBy(groupedEvents, function(item) {
          return parseInt(item, 10);
        }).reverse();

        for (var i in groupedEvents) {
          if (Object.prototype.hasOwnProperty.call(groupedEvents, i)) {
            groupedEvents[i] = this.reverseSortAttr(groupedEvents[i], 'time');
            var formatPeriodName = this.formatPeriodName(groupedEvents[i][0]);
            groupedEvents[i].periodName =
              formatPeriodName !== '' ? formatPeriodName : '';
            groupedEvents[i].periodResult = this.findPeriodResult(
              groupedEvents[i][0],
              response
            );
          }
        }
        response.events.groupedEvents = groupedEvents;
      }
    }
    return response;
  };

  svs.themes.sport_soccer.doFormatModelData = function(data) {
    var response = data;
    if (_.isObject(response.events)) {
      if (_.isObject(response.events.goals)) {
        this.removeInsufficientEvents(response.events.goals);
        response.events.goals = _.sortBy(response.events.goals, function(item) {
          return parseInt(item.time, 10);
        });

        response.events.goals = this.formatGoalResult([
          response.events.goals
        ])[0];
        response.events.goals = this.reverseSortAttr(
          response.events.goals,
          'time'
        );
      }
    }
    if (_.isObject(response.events)) {
      if (_.isObject(response.events.cards)) {
        response.events.cards = this.reverseSortAttr(
          response.events.cards,
          'time'
        );
        this.removeInsufficientEvents(response.events.cards);
      }
    }
    if (_.isObject(response.events)) {
      if (_.isObject(response.events.substitutions)) {
        response.events.substitutions = this.reverseSortAttr(
          response.events.substitutions,
          'time'
        );
        this.removeInsufficientEvents(response.events.substitutions);
      }
    }
    return response;
  };

  svs.themes.sport_soccer.groupEvents = function(statistics) {
    if (_.isObject(statistics) && _.has(statistics, 'matchEvents')) {
      statistics.matchEvents = _.sortBy(statistics.matchEvents, function(item) {
        return parseInt(item.time, 10);
      });

      statistics.matchEvents = this.formatGoalResult([
        statistics.matchEvents
      ])[0];
      statistics.matchEvents = this.reverseSortAttr(
        statistics.matchEvents,
        'time'
      );

      return statistics.matchEvents;
    }
    return null;
  };

  svs.themes.sport_soccer.removeInsufficientEvents = function(dataList) {
    var doRemove = false;
    for (var i = 0; i < dataList.length; i++) {
      doRemove = false;
      if (this.isSubstitutionEvent(dataList[i])) {
        if (!(dataList[i].playerIn || {}).name) {
          doRemove = true;
        }
        if (!(dataList[i].playerOut || {}).name) {
          doRemove = true;
        }
      } else if (
        this.isCardEvent(dataList[i]) ||
        this.isGoalEventLive(dataList[i]) ||
        this.isGoalEvent(dataList[i])
      ) {
        if (!(dataList[i].player || {}).name) {
          doRemove = true;
        }
      }

      if (doRemove) {
        dataList.splice(i, 1);
        i--;
      }
    }
  };

  svs.themes.sport_soccer.isSubstitutionEvent = function(event) {
    return event.type === 'substitution';
  };

  svs.themes.sport_soccer.isCardEvent = function(event) {
    return event.type === 'card';
  };

  svs.themes.sport_soccer.isGoalEventLive = function(event) {
    return event.type === 'goal';
  };

  svs.themes.sport_soccer.isGoalEvent = function(event) {
    return event.goalType >= 0;
  };

  svs.themes.sport_soccer.formatGoalResult = function(dataList) {
    this.homeGoal = 0;
    this.awayGoal = 0;
    var _self = this;
    _.each(dataList, function(data) {
      _self.doFormatGoalResult(data);
    });
    return dataList;
  };
  svs.themes.sport_soccer.doFormatGoalResult = function(data) {
    var _self = this,
      goalResult = [],
      homeResult = 0,
      awayResult = 0;

    _.each(data, function(goal) {
      if (_.isString(goal.result)) {
        goalResult = goal.result.split('-');
        homeResult = goalResult[0];
        awayResult = goalResult[1];

        if (parseInt(homeResult, 10) > _self.homeGoal) {
          goal.homeChange = true;
          _self.homeGoal = parseInt(homeResult, 10);
        } else {
          goal.homeChange = false;
        }

        if (parseInt(awayResult, 10) > _self.awayGoal) {
          goal.awayChange = true;
          _self.awayGoal = parseInt(awayResult, 10);
        } else {
          goal.awayChange = false;
        }
      }
    });
  };

  svs.themes.sport_soccer.formatPeriodName = function(groupedDataItem) {
    switch (groupedDataItem.period) {
      case 1:
        return '1:a halvlek';
      case 2:
        return '2:a halvlek';
      case 3:
        return '1:a övertidsperiod';
      case 5:
        return '2:a övertidperiod';
      case 99:
        return 'Straffar';
      default:
    }
  };

  svs.themes.sport_soccer.findPeriodResult = function(
    groupedDataItem,
    response
  ) {
    var FIRST_PERIOD = 1;
    var SECOND_PERIOD = 2;
    var EXTRA_TIME_0 = 3;
    var EXTRA_TIME_1 = 10;
    var PENALTIES = 4;

    var oResult = response.events.result;

    switch (groupedDataItem.period) {
      case 1:
        return this.findPeriodResultById(FIRST_PERIOD, oResult);
      case 2:
        return this.findPeriodResultById(SECOND_PERIOD, oResult);
      case 3:
        return this.findPeriodResultById(EXTRA_TIME_0, oResult);
      case 5:
        return this.findPeriodResultById(EXTRA_TIME_1, oResult);
      case 99:
        return this.findPeriodResultById(PENALTIES, oResult);
      default:
    }
  };

  svs.themes.sport_soccer.findPeriodResultById = function(needle, hay) {
    for (var i = 0; i < hay.length; i++) {
      if (needle === hay[i].type) {
        if (hay[i].homePeriod && hay[i].awayPeriod) {
          return hay[i].homePeriod + ' - ' + hay[i].awayPeriod;
        }
        return '';
      }
    }
    return '';
  };

  svs.themes.sport_soccer.formatedMatchResult = function(
    match,
    homeOrAway,
    showHyphen
  ) {
    match = match || {};
    var homeResult = showHyphen ? '-' : '',
      awayResult = showHyphen ? '-' : '';

    var constants = svs.themes.constants;

    if (match.result && match.result.length > 0) {
      var result = svs.utils.result.getResult(match);

      if (!result && typeof match.result === 'object') {
        result = match.result;
      }
      if (result) {
        homeResult = result.home;
        awayResult = result.away;
      }
    } else if (
      !!(match || {}).status &&
      (match || {}).homeTeam &&
      !!(match || {}).awayTeam
    ) {
      if (match.status !== 33) {
        homeResult = match.homeTeam.result ? match.homeTeam.result : homeResult;
        awayResult = match.awayTeam.result ? match.awayTeam.result : awayResult;
      } else {
        _.each(match.result, function(r) {
          if (
            r.type !== constants.PENALTIES_RESULT &&
            r.type !== constants.CURRENT_RESULT &&
            r.type !== constants.ODDS_INFO_CURRENT
          ) {
            homeResult = r.home;
            awayResult = r.away;
          }
        });
      }
    }
    if (homeOrAway === 'home') {
      return homeResult;
    } else if (homeOrAway === 'away') {
      return awayResult;
    }
    if (homeResult === '' || awayResult === '') {
      return ' - ';
    }
    return homeResult + ' - ' + awayResult;
  };

  svs.themes.sport_soccer.hasResultOrLazy = function(match, isLazy) {
    if (isLazy) {
      return true;
    }

    match = match || {};
    if (match.result && match.result.length > 0) {
      var result = svs.utils.result.getResult(match);

      if (result) {
        return true;
      }
    }

    return false;
  };

  svs.themes.sport_soccer.getThemedExtraResult = function(match) {
    var resultList = match.result;
    var resultStr = '';
    if (_.isObject(match.result)) {
      _.each(resultList, function(oResult) {
        if (_.isObject(oResult)) {
          if (oResult.type === 1) {
            if (oResult.homePeriod && oResult.awayPeriod) {
              resultStr +=
                '(' + oResult.homePeriod + ' - ' + oResult.awayPeriod + ')';
              return false;
            }
          }
        }
      });
    }
    return resultStr;
  };

  svs.themes.sport_soccer.filterEvent = function(periodList) {
    var eventList = null;
    if (!_.isArray(periodList)) {
      return;
    }

    for (var index = 0; index < periodList.length; index++) {
      eventList = periodList[index];
      for (var i = 0; i < eventList.length; i++) {
        if (i < eventList.length - 1) {
          if (
            (eventList[i].type === 'goal' &&
              eventList[i].time === eventList[i + 1].time &&
              eventList[i + 1].type === 'matcheventitem') ||
            (eventList[i].type === 'card' &&
              eventList[i].time === eventList[i + 1].time &&
              eventList[i + 1].type === 'matcheventitem') ||
            (eventList[i].type === 'substitution' &&
              eventList[i].time === eventList[i + 1].time &&
              eventList[i + 1].type === 'matcheventitem')
          ) {
            eventList.splice(i + 1, 1);
          }
        }
      }
    }
  };

  svs.themes.sport_soccer.reverseSortAttr = function(response, attr) {
    var items = response;
    items = _.sortBy(items, function(item) {
      return parseInt(item[attr], 10);
    }).reverse();

    return items;
  };

  svs.themes.sport_soccer.sortAttr = function(response, attr) {
    var items = response;
    items = _.sortBy(items, function(item) {
      return parseInt(item[attr], 10);
    });

    return items;
  };

  svs.themes.sport_soccer.isLazy = function(model) {
    var isLazy = false, 
      status = model.get('status'),
      startTime = model.get('actualStartTime') || model.get('startTime'),
      hoursUntilLazy = 6;

    if (
      status === 26  ||
      (!svs.themes.sport_soccer.isEnded(status) &&
        svs.themes.isDateHoursDiff(startTime, hoursUntilLazy))
    ) {
      isLazy = true;
    }

    return isLazy;
  };

  svs.themes.sport_soccer.hasPenalties = function() {
    return false;
  };

  svs.themes.sport_soccer.getFullTimeResult = function(match) {
    if (match && match.result) {
      return _.findWhere(match.result, {
        type: 2
      });
    }
    return false;
  };
})(svs, _);

 })(window);